import { Construtor } from './construtor';

export class ResultadoInconsistencia implements Construtor<ResultadoInconsistencia> {

  public idCliente: number;
  public idUsuario: number;
  public nomeUsuario: string;
  public pontosFisicos: number;
  public setores: number;
  public processos: number;
  public checklists: number;
  public dataInicioReferencia: Date;
  public dataFimReferencia: Date;

  constructor(object?: any) {
    if (object !== undefined) {
      if (object instanceof (ResultadoInconsistencia)) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
  }

  parseFromJson(resultado: any): void {
    this.idCliente = resultado.idCliente;
    this.idUsuario = resultado.idUsuario;
    this.nomeUsuario = resultado.nomeUsuario;
    this.pontosFisicos = resultado.pontosFisicos;
    this.setores = resultado.setores;
    this.processos = resultado.processos;
    this.checklists = resultado.checklists;
  }

  copyObject(resultado: ResultadoInconsistencia): void {
    this.idCliente = resultado.idCliente;
    this.idUsuario = resultado.idUsuario;
    this.nomeUsuario = resultado.nomeUsuario;
    this.pontosFisicos = resultado.pontosFisicos;
    this.setores = resultado.setores;
    this.processos = resultado.processos;
    this.checklists = resultado.checklists;
  }

  modeloCompleto(): boolean {
    return this.idUsuario !== undefined && this.nomeUsuario !== undefined && this.idCliente !== undefined;
  }

  getNewInstance(object?: any): ResultadoInconsistencia {
    return new ResultadoInconsistencia(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/resultado-inconsistencia.ts